import { faVideoSlash } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProductiveHeading06 } from 'components/styles';

const Wrapper = styled.div`
  height: 258px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 var(--spacing-09);
  align-items: flex-start;
`;

const Content = styled.div`
  margin-top: var(--spacing-05);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
`;

const Title = styled.div`
  ${ProductiveHeading06};
`;

const Description = styled.div``;

export const NoMeetingsFound = () => {
  return (
    <Wrapper>
      <FontAwesomeIcon size="3x" icon={faVideoSlash} />
      <Content>
        <Title>
          <FormattedMessage id="ai_fill.meetings.select.empty.title" />
        </Title>
        <Description>
          <FormattedMessage id="ai_fill.no_meetings_search.description" />
        </Description>
      </Content>
    </Wrapper>
  );
};
